import { render, staticRenderFns } from "./BehaviouralDetail.vue?vue&type=template&id=13b5f466&scoped=true"
import script from "./BehaviouralDetail.vue?vue&type=script&lang=js"
export * from "./BehaviouralDetail.vue?vue&type=script&lang=js"
import style0 from "./BehaviouralDetail.vue?vue&type=style&index=0&id=13b5f466&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b5f466",
  null
  
)

export default component.exports